import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Config from '../../../../Config';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import OtpVerifyCode from '../Partials/OtpVerifyCode/OtpVerifyCode';
import Footer from '../Partials/Footer/Footer';
import { setIsSubmit, setOtpErrorMsg,createOtp, validateOtp, setOtpCode, reportDWH } from '../electricCompanyLeadBlockSlice';

const OtpVerifyCodePage = (props) => {

  //page params
  let btnText = 'אפשר להמשיך';
  let linkText = 'הקוד לא הגיע, שלחו לי שוב';
  let currentPageFunction = handlePageContinue;
  let formid = 'electricCompanyLead';
  const numberOfInputs = 6;
  //page params

  useEffect(() => {
    props.reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: 'Otp Electric Comp - Display' });
    gtag4({
      event: 'CounterCheck_Step2_OtpPage',
      step: '2',
      action: 'OtpPage',
    });
  }, []);

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='title'>מתקדמים לחשמל של {window.Config.brand_Name_HE}</h1>
      <h2 className='sub-title'>מה הקוד שקיבלת?</h2>
    </div>
  );

  const handleOnChange = (otp) => {
    props.setOtpCode(otp);
  };

  let currentPageView = (
    <>
      <OtpVerifyCode numberOfInputs={numberOfInputs} onChange={handleOnChange} error={props.otpDetails.error} verifyCode={props.otpDetails.verifyCode} />
      <div className='info-text'>
        <h3 className='title'>חשוב לדעת</h3>
        <p className='text'>הודעת ה-sms תגיע מחברת החשמל תוך מספר דקות</p></div>
    </>
  );

  return (
    <div className='electric-company-lead-wrapper'>
      {currentPageHeadline}
      <div className='electric-company-lead-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <Footer btnText={btnText} onclick={currentPageFunction} linkText={linkText} onClickLink={handleOnClickLink} formid={formid} />
      </div>
    </div>
  );

  function handlePageContinue() {
    props.setOtpErrorMsg('');
    props.reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: 'Otp Electric Comp - Click' });
    gtag4({
      event: 'CounterCheck_Step2_OtpClick',
      step: '2',
      action: 'OtpClick',
      button: btnText
    });
    if (props.otpDetails.verifyCode.length != numberOfInputs) {
      props.setOtpErrorMsg(`יש להזין ${numberOfInputs} תווים`)
      return;
    }
    props.validateOtp();
  }

  function handleOnClickLink() {
    props.setOtpErrorMsg('');
    if (props.otpDetails.numOfAttempts >= Config.verifyCodeAttemptsLimit) {
      props.setOtpErrorMsg('לא ניתן לבצע ניסיונות נוספים');
      return;
    }
    if (props.formDetails.phoneNumber) {
      props.createOtp();
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    isSubmit: state.electricCompanyLeadBlock.isSubmit,
    otpDetails: state.electricCompanyLeadBlock.otpDetails,
    formDetails: state.electricCompanyLeadBlock.formDetails,

    //other states
  };
};

const mapDispatchToProps = {
  setIsSubmit,
  setOtpCode,
  setOtpErrorMsg,
  validateOtp,
  createOtp,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerifyCodePage);
